import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "../HolidayMode/HolidayModeCardContentLayout.module.css";
import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg";
import Pill_Widget from '../../../Widgets/Pill_Widget';
import Modal from '../../../../Modal/Modal';
import List from './List';
import AffectedSwitchesList from './AffectedSwitchesList';
import Button1 from '../../../Button/Button1';
import { addActionToAdvRule, deleteAdvRule, getSiteByUUID, removeActionFromAdvRule, setAdvRuleEnabled, setInputRuleApi } from '../../../../../Api Methods/Api';
import { useDispatch, useSelector } from 'react-redux';
import Button2 from '../../../Button/Button2';
import areYouSureAnim from '../../../../../assets/animations/areYouSure.json'
import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import { act } from 'react';
import { Description } from '@headlessui/react';
import { format } from 'date-fns';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import ChoosePin from '../CreateRuleNew/ChoosePin';
import { Divider } from 'primereact/divider';
import ChooseWhatAdvRule from '../CreateRuleNew/ChooseWhatAdvRule';
import AddAdvRuleAction from '../CreateRuleNew/AddAdvRuleAction';
import ChooseWhatAddAdvRuleAction from '../CreateRuleNew/ChooseWhatAddAdvRuleAction';
import { RuleProvider, useRule } from '../CreateRuleNew/RuleReducer';
import { Link } from 'react-router-dom';


const AdvRuleLayout = ({ item, fetchAutomations, pins, smartLocks }) => {

    const { rule, conditions, actions } = item;
    const { state, dispatch } = useRule(RuleProvider);
    console.log(rule)
    console.log(conditions)
    console.log(actions)
    console.log(smartLocks)
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const [allSites, setAllSites] = useState({});
    const [_actions, setActions] = useState(actions);
    const [_rule, setRule] = useState(rule);
    const [masterSite, setMasterSite] = useState("")
    let usedKeys = []

    const ruleName = _rule.name || "No name provided"
    const ruleOwner = rule.site_owner
    const ruleDescription = _rule.description || "No description provided"
    const ruleEnabled = _rule.is_enabled == 1
    const created = _rule.created_at
    const createdBy = _rule.created_by_name || "Unknown user"
    const lastUpdated = _rule.updated_at
    const ruleID = _rule.rule_id

    const [showEditRule, setShowEditRule] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showAddAction, setShowAddAction] = useState(false)
    const [showChooseWhat, setShowChooseWhat] = useState(false)

    const [newSelectedPin, setNewSelectedPin] = useState({})

    const [linkedSites, setLinkedSites] = useState([])

    const apiData = {
        token,
        client
    }

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    useEffect(() => {
        if (!rule) return;
        getSiteInfo(_rule.site_owner);
        // _actions.map(action => {
        //     setLinkedSites(getSiteInfo(action.site_to))
        // })
        


        const uniqueActionSites = [
            ...new Set(_actions.map(a => a.site_to).filter(id => id !== _rule.site_owner))
        ];

        uniqueActionSites.forEach(uuid => getSiteInfo(uuid));

        console.log(uniqueActionSites)
    }, [_rule, _actions]);

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }
        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("")
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setModalPageIndex(null);
    }

    // re-render modal to show new modal componet. 
    useEffect(() => {
        switch (modalPageIndex) {
            case 1:
                //setModalComponent(<ScheduledAction body={body} OutPutOptions={OutPutOptions} title={title} isReminder={isReminder} nextPage={setModalPageIndex} onSubmit={UpdateSchedule} DeleteSchedule={DeleteSchedule} showRemoveScheduleButton={showRemoveScheduleButton} />)
                HandleShowModal();
                break;
            case 3:
                //setModalComponent(<SelectOutputs body={body} setBody={setBody} listItems={OutPutOptions} modalPageIndex={modalPageIndex} nextPage={setModalPageIndex} showAutomation={isReminder} time={time} />)
                break;
        }

    }, [modalPageIndex, item])


    const apiDispatch = useDispatch();


    const deleteRule = async () => {
        const response = await deleteAdvRule(apiData, ruleID, apiDispatch)
        if (response.success) {

            HandleCloseModal()
            setShowEditRule(false)
            setShowConfirmation(false)
            setShowSuccess(true)

        } else {
            setShowConfirmation(false)
            setShowFail(true)
        }

    }

    const convertDaysOfTheWeek = (daysSelected) => {
        const Days = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];
        const selectedDayNames = daysSelected
            .slice()
            .sort((a, b) => a - b)
            .map(dayNumber => Days[dayNumber])
            .join(',');

        if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri") {
            return "on weekdays";
        } else if (selectedDayNames === "Sat,Sun") {
            return "on weekends";
        } else if (selectedDayNames === "Mon,Tues,Wed,Thur,Fri,Sat,Sun") {
            return "everyday"
        }
        else {
            return "on " + selectedDayNames.split(',').join(', ');
        }
    }

    const getSiteInfo = async (uuid) => {
        if (!uuid) return;

        const response = await getSiteByUUID(apiData, uuid, apiDispatch);
        if (response.success) {
            console.log(response.data)
            const deviceDetailsParsed = JSON.parse(response.data.deviceDetails);

            setAllSites(prev => ({
                ...prev,
                [uuid]: {
                    ...response.data,
                    deviceDetailsParsed
                }
            }));
        }
    };

    const convertConditionPinState = (deviceDetails, pinNumber, pinState) => {
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";

        const pin = deviceDetails[pinNumber];
        console.log(pin)
        console.log(smartLocks)
        console.log(pinNumber)
        const isLock = smartLocks.some(lock => lock.outputPin == pinNumber);
        console.log(pinState)

        switch (pinState) {
            case "ARMED":
                return isLock ? "closed" : pin.pinStatusOn;
            case "DISARMED":
                return isLock ? "opened" : pin.pinStatusOff;
            case "TEMP_ARM":
                return `temporarily ${pin.pinStatusOn}`
            case "TEMP_DISARM":
            case "PULSE":
                return `temporarily ${pin.pinStatusOff}`
            case "ANY":
                return isLock ? "opened or closed" : `${pin.pinStatusOn} or ${pin.pinStatusOff}`;
            default:
                return "Unknown";
        }
    };

    const convertActionPinState = (deviceDetails, pinNumber, pinState) => {
        if (!deviceDetails || !deviceDetails[pinNumber]) return "Loading...";
        console.log(pinState)

        switch (pinState){
            case "MATCH" :
                return `match its state`
            case "ARM":
                return `${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "DISARM": 
                return `${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "PULSE":
                return `temporarily ${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "TEMP_ARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOffLabel || "arm"}`
            case "TEMP_DISARM":
                return `temporarily ${deviceDetails[pinNumber].actionOneOnLabel || "disarm"}`
            case "TOGGLE":
                return "toggle"
            default: 
                return "Unknown"
        }
    }

    const setRuleEnabled = async () => {
        const body = {
            enabled: _rule.is_enabled == 1 ? false : true
        }

        const response = await setAdvRuleEnabled(apiData, body, _rule.rule_id, apiDispatch)
        if (response.success){
            const updatedRule = {
                ..._rule,
                is_enabled: _rule.is_enabled == 1 ? 0 : 1
            };
            setRule(updatedRule)
        }
    }

    const deleteAction = async (actionID) => {
        const response = await removeActionFromAdvRule(apiData, actionID, apiDispatch)
        if (response.success){
            setActions(prev =>
                    prev.filter(a => a.action_id !== actionID)
            );
        }
    }

    const navigate = () => {
        setShowAddAction(false)
        setShowChooseWhat(true)
    }

    const saveNewAction = async () => {
        setShowChooseWhat(false)
        console.log(state.actionToAdd)
        const response = await addActionToAdvRule(apiData, _rule.rule_id, state.actionToAdd, apiDispatch)
        if (response.success){
             const updatedActions = [..._actions, state.actionToAdd];
             setActions(updatedActions)
        }
    }

    // const navigateToSite = (uuid) => {
    //     dispatch(serviceActions.setDeviceUUID(uuid));
    //     useSetCookie("DeviceUUID", uuid, 1);
    //     navigate("/portal/SiteView/" + uuid);
    // }


    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            {allSites[_rule.site_owner] && (
                <Dialog
                    header="View rule"
                    visible={showEdit}
                    style={{ width: "40vw", maxHeight: "70vh", overflowY: "auto" }}
                    onHide={() => setShowEdit(false)}
                >

                    <p>
                        {`Rule owner: ${allSites[_rule.site_owner].tag || ""} (${allSites[_rule.site_owner].key})`}
                    </p>
                    <p>
                        {`Name: ${_rule.name}`}
                    </p>
                    <p>
                        {`Description: ${_rule.description}`}
                    </p>
                    <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        {_rule.is_enabled == 1 ? "Rule status: enabled" : "Rule status: disabled"}
                        <Button icon="pi pi-arrow-right-arrow-left" rounded text aria-label="Filter" onClick={() => setRuleEnabled()}/>
                    </p>
                    <p>{`Created: ${format(new Date(_rule.created_at), "MMM do, yyyy - HH:mm")}`}</p>
                    <Divider type='solid' />
                   <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Trigger:</h3>
                    {conditions.map(condition => {
                        const site = allSites[_rule.site_owner]; // master site
                     
                        if (!site) return null;
                        const deviceDetails = site?.deviceDetailsParsed;
                        return (
                            <div key={condition.condition_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                {`When ${deviceDetails?.[condition.pin]?.pinName || 'Loading...'} 
                                is ${convertConditionPinState(deviceDetails, condition.pin, condition.pin_state || "PULSE")} 
                                ${condition.time_window_start && condition.time_window_end 
                                    ? `Between ${condition.time_window_start} and ${condition.time_window_end}` 
                                    : ''
                                } 
                                ${convertDaysOfTheWeek(JSON.parse(condition.days_of_week))}`}

                                {/* <Button icon="pi pi-pen-to-square" rounded text aria-label="Filter" /> */}
                                </p>
                            </div>
                        );
                    })}
                    <Divider type='solid' />
                    <h3 style={{color:"#6e6e6eff", fontWeight:600}}>Actions:</h3>
                    {_actions.map(action => {
                        
                        const site = allSites[action.site_to];
                        if (!site) return null;
                        {console.log(site)}
                        const tag = site.tag && site.tag || ""
                        const deviceDetails = site?.deviceDetailsParsed;
                        return (
                            <div key={action.action_id}>
                                <p style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                    {`${tag || ""} (${site.key}) - 
                                    ${deviceDetails?.[action.target_output]?.pinName || 'Loading...'} 
                                    will ${convertActionPinState(deviceDetails, action.target_output, action.control_type)}
                                    ${action.temporary_time_ms ? `For ${action.temporary_time_ms / 60000} minutes` : ''}
                                    ${action.delay_seconds > 0 ? `After ${action.delay_seconds} seconds` : ''}`}
                                    <Button icon="pi pi-trash" rounded text aria-label="Filter" onClick={() => deleteAction(action.action_id)} />

                                </p>
                                <Divider type='dashed' />
                            </div>

                        );
                    })}
                    
                    <Button label="Add an action" severity="info" rounded icon="pi pi-plus" onClick={() => {setShowAddAction(true)}} />

                </Dialog>)}

            <Dialog
                header="Add super rule action"
                visible={showAddAction}
                style={{ width: "40vw" }}
                onHide={() => setShowAddAction(false)}
            >
                <AddAdvRuleAction rule={_rule} actions={_actions} conditions={conditions} pins={pins} smartLocks={smartLocks} closeDialog={() => navigate()} setNewSelectedPin={setNewSelectedPin}/>
            </Dialog>

            <Dialog 
                header="Add action"
                visible={showChooseWhat}
                style={{ width: "40vw" }}
                onHide={() => setShowChooseWhat(false)}
            >
                <ChooseWhatAddAdvRuleAction selectedPinToAffect={newSelectedPin[0]} closeDialog={() => saveNewAction()} />
            </Dialog>

            <Dialog
                header="Success"
                visible={showSuccess}
                style={{ width: "40vw" }}
                onHide={() => setShowSuccess(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{ color: "#6e6e6eff" }}>Action completed successfully</h3>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />

                    <Button label="Close & refresh" icon="pi pi-times" rounded severity="primary" onClick={() => { setShowSuccess(false); fetchAutomations(); }} />
                </div>
            </Dialog>

            <Dialog
                header="Error"
                visible={showFail}
                style={{ width: "40vw" }}
                onHide={() => setShowFail(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>Something went wrong!</h3>
                    <p style={{ textAlign: "center" }}>Failed to complete requested action, please try again.</p>
                    <br></br>

                    <Button label="Okay" rounded severity="secondary" onClick={() => setShowFail(false)} />
                </div>
            </Dialog>

            <Dialog
                header="Are you sure?"
                visible={showConfirmation}
                style={{ width: "40vw" }}
                onHide={() => setShowConfirmation(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to delete this super rule?`}</h3>
                    <br />
                    <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setShowConfirmation(false)} />
                    <br />
                    <Button label="Yes, delete rule" rounded icon="pi pi-check" severity="danger" onClick={() => deleteRule()} />

                </div>
            </Dialog>

            <Dialog
                header="Edit super rule"
                visible={showEditRule}
                style={{ width: "40vw" }}
                onHide={() => setShowEditRule(false)}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px', // Spacing between buttons
                    padding: '15px',
                    width: '100%', // Adjust width as needed
                    background: 'white',
                    borderRadius: '8px',
                    alignContent: "center",
                    alignItems: "center"
                }}>
                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                    }}
                        onClick={() => {setShowEdit(true); setShowEditRule(false)}}>View/edit rule</Button2>

                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#ff5c5c"
                    }}
                        onClick={() => setShowConfirmation(true)}>Delete rule</Button2>

                    <Button2 style={{
                        minWidth: "350px",
                        minHeight: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        onClick={() => setShowEditRule(false)}>Cancel</Button2>
                </div>


            </Dialog>

            <div className={classes.contentContainer} >
                <div className={classes.top} onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null}>

                    <h3 className={classes.title} onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null}>Super rule</h3>

                    <Pill_Widget onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null} boolean={ruleEnabled} PillColor_IfTrue={"var(--Active-color)"} PillColor_IfFalse={"var(--Inactive-color)"} text_IfTrue={"Active"} text_IfFalse={"Inactive"} className={classes.PillHeight} />

                </div>
                <h4 onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null} className={classes.subtitle}>{ruleName}</h4>
                <div onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null} className={classes["bottom-wrapper"]}>
                    <h5 className={classes.description}>{ruleDescription}</h5>
                </div>
                {/* <div className={classes["bottom-wrapper"]}>
                    <h4 className={classes.subtitle}>{`Rule owner: ${allSites[_rule.site_owner].tag}`}</h4>
                </div> */}
                
                
                
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "6px", flexWrap: "wrap", marginTop:"10px" }}>
                    {/* <h4 className={classes.subtitle}>{`Linked with:`}</h4> */}

                    {_actions.map(action => {
                        const affectedSite = allSites[action.site_to];
                        const ruleOwner = allSites[_rule.site_owner]
                        
                        if (!affectedSite) return null;
                        if (!ruleOwner) return null;
                        
                        
                        if (affectedSite.uuid != DeviceUUID && !usedKeys.includes(affectedSite.key)) {
                            usedKeys.push(affectedSite.key);
                            return (
                                 <h4 key={action.action_id} className={classes.subtitle}>
                                    Linked with:{" "}
                                    <a
                                        href={`/Dashboard/SiteView/${affectedSite.uuid}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {affectedSite.key}
                                    </a>
                                </h4>
                            );
                        }

                        //if the rule owner is not this site
                        if (ruleOwner.uuid != DeviceUUID && !usedKeys.includes(rule.site_owner)){
                            usedKeys.push(rule.site_owner);
                            return (
                                 <h4 key={action.action_id} className={classes.subtitle}>
                                    Rule owned by{" "}
                                    <a
                                        href={`/Dashboard/SiteView/${rule.site_owner}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {ruleOwner.key}
                                    </a>
                                      
                                </h4>
                            );
                        }
                    })}
                </div>
       
                <br/>
                {created && (
                    <small onClick={() => ruleOwner == DeviceUUID ? setShowEditRule(true) : null} className={classes.createdTextRule} style={{marginTop:"10px"}}>
                        {`Created by ${createdBy} on ${format(new Date(created), "MMM do, yyyy - HH:mm")}`}
                    </small>
                )}
            </div>
        </>
    )
}

export default AdvRuleLayout;




